/**
 * The Pay API origin the ops console talks to.
 *
 * ONE definition, for the same reason as `CS_BASE` beside it: this was
 * copy-pasted into 35 files, each with its own hand-typed fallback. The host
 * rules live in `@parkify/api-client` (`resolveApiBase`), shared with patrol,
 * consumer and tenant-portal.
 *
 * ops reads `VITE_PAYMENT_API_BASE` (its historical name, with the
 * `/api/payments` suffix stripped) and NOT `VITE_API_BASE`, so an ambient value
 * meant for another app can never repoint the console. Unset means
 * `https://api.parkify.com`, the only production host.
 *
 * Evaluated on import. `test-setup.ts` deletes any pinned VITE_PAYMENT_API_BASE
 * before a test file imports this, so suites always see the production default.
 */
import { createCaller, resolveApiBase } from '@parkify/api-client'

export const API_BASE = resolveApiBase({
  VITE_PAYMENT_API_BASE: import.meta.env.VITE_PAYMENT_API_BASE as string | undefined,
})

/**
 * `callApi(path, init)` sends the same request the console's old inline calls
 * sent to API_BASE + path: same URL, the same init object, and the Response
 * back for every status. Each call site keeps its own error handling; only the
 * base moved here. It resolves `window.fetch` at call time, so the 401 and
 * view-as guards in auth/AuthContext.tsx and the demo interceptor still see
 * every request.
 */
export const callApi = createCaller(API_BASE)
